<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="2">
        <v-autocomplete v-model="queryForm.own_type" :items="own_types" label="车辆归属"
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined clearable hide-details />
      </v-col>
      <v-col cols="12" md="2">
        <v-autocomplete v-model="queryForm.type" :items="types" label="车辆类型"
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined clearable hide-details />
      </v-col>
      <v-col cols="12" md="2">
        <v-autocomplete v-model="queryForm.vehicle_types" :items="vehicle_types" label="车辆吨数"
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined clearable hide-details />
      </v-col>
      <v-col cols="12" md="6">
        <a-space>
          <v-btn color="primary" tile style="color:#fff;" @click="getdata()">
            <v-icon small>mdi-magnify</v-icon> 查询
          </v-btn>
          <v-btn color="success" tile @click="showaddgroup">
            <v-icon small>mdi-plus</v-icon> 新增车辆成本
          </v-btn>
        </a-space>
      </v-col>
    </v-row>
    <v-card tile class="mt-2">
      <a-table size="small" :columns="headers" :data-source="list" :pagination="false" :locale="{ emptyText: '暂无数据' }"
        :scroll="{ x: width }" row-key="_id" expandRowByClick>
        <template slot="index" slot-scope="text, record, index">
          {{ index + 1 }}
        </template>
        <template slot="own_type" slot-scope="text, record">
          <template v-for="item in own_types">
            <span v-if="record.own_type === item.value" :key="item.value" :style="{
              'color': $utils.textToBgColor(item.label)
            }">{{ item.label }}</span>
          </template>
        </template>
        <template slot="type" slot-scope="text, record">
          <template v-for="item in types">
            <span v-if="record.type === item.value" :key="item.value" :style="{
              'color': $utils.textToBgColor(item.label)
            }">{{ item.label }}</span>
          </template>
        </template>
        <template slot="include_driver" slot-scope="text, record">
          <p v-if="record.include_driver === 'YES'" class="success--text">是</p>
          <p v-if="record.include_driver === 'NO'" class="error--text">否</p>
        </template>
        <template slot="count" slot-scope="text, record">
          <p>
            <span class="success--text">{{ record.count }}</span>/<span class="error--text">{{ record.tcount }}</span>
          </p>
        </template>
        <template slot="create_time" slot-scope="text, record">
          <p>{{ record.create_time }}</p>
          <p>{{ record.create_by }}</p>
        </template>
        <template slot="update_time" slot-scope="text, record">
          <p>{{ record.update_time }}</p>
          <p>{{ record.update_by }}</p>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space>
            <v-btn size="small" text tile color="primary" @click.stop="showadditem(record._id)"> 添加费用 </v-btn>
            <v-btn size="small" text tile color="success" @click.stop="showeditgroup(record)"> 编辑 </v-btn>
            <a-popconfirm title="删除数据" ok-text="确定" cancel-text="取消" placement="left"
              @confirm="removegroup(record._id)">
              <v-btn size="small" text tile color="error" @click.stop> 删除 </v-btn>
            </a-popconfirm>
          </a-space>
        </template>
        <template slot="expandedRowRender" slot-scope="record" style="margin: 0">
          <a-table size="small" :columns="sheaders" :data-source="record.items" :pagination="false"
            :locale="{ emptyText: '暂无数据' }" :scroll="{ x: swidth }" row-key="_id">
            <template slot="index" slot-scope="text, record, index">
              {{ index + 1 }}
            </template>
            <template slot="cycle" slot-scope="text, record">
              <span v-if="record.cycle === 'day'" class="error--text">按天</span>
              <span v-if="record.cycle === 'month'" class="orange--text">按月</span>
              <span v-if="record.cycle === 'year'" class="primary--text">按年</span>
            </template>
            <template slot="duration" slot-scope="text, record">
              <span>{{ record.date1 }}~{{ record.date2 }}</span>
            </template>
            <template slot="action" slot-scope="text, record">
              <v-btn size="small" text tile color="success" @click.stop="showedititem(record)"> 编辑 </v-btn>
              <a-popconfirm title="删除数据" ok-text="确定" cancel-text="取消" placement="left"
                @confirm="removeitem(record._id)">
                <v-btn size="small" text tile color="error" @click.stop> 删除 </v-btn>
              </a-popconfirm>
            </template>
          </a-table>
        </template>
      </a-table>
    </v-card>
    <v-dialog v-model="groupmodel" persistent max-width="400px">
      <v-form ref="groupformref" v-model="groupvalid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ grouptitle }}
            <v-icon @click="cancelsavegroup">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container style="max-height:600px;overflow-y:auto;">
              <v-row>
                <v-col cols="12">
                  <v-autocomplete v-model="groupform.own_type" :items="own_types" :rules="[vrules.required]"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined>
                    <template v-slot:label>
                      车辆归属 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                  <v-autocomplete v-model="groupform.type" :items="types" :rules="[vrules.required]"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined>
                    <template v-slot:label>
                      车辆类型 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                  <v-autocomplete v-if="groupform.own_type === 3 && groupform.type === 3"
                    v-model="groupform.include_driver" :items="[
                      { value: 'YES', text: '是' },
                      { value: 'NO', text: '否' },
                    ]" :rules="[vrules.required]" :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense
                    outlined>
                    <template v-slot:label>
                      带司机 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                  <v-autocomplete v-model="groupform.vehicle_type" :items="vehicle_types" :rules="[vrules.required]"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined>
                    <template v-slot:label>
                      车辆吨数 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                  <v-autocomplete v-model="groupform.brand" :items="vehicle_brands"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined clearable>
                    <template v-slot:label>
                      品牌名称
                    </template>
                  </v-autocomplete>
                  <v-textarea v-model="groupform.remark" placeholder="备注" persistent-placeholder outlined rows="2"
                    dense>
                    <template v-slot:label>
                      备注
                    </template>
                  </v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" tile :disabled="!groupvalid" @click="savegroup">确定</v-btn>
            <v-btn tile @click="cancelsavegroup">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="itemmodel" persistent max-width="400px">
      <v-form ref="itemformref" v-model="itemvalid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ itemtitle }}
            <v-icon @click="cancelsaveitem">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container style="max-height:600px;overflow-y:auto;">
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="itemform.name" :rules="[vrules.required]" dense outlined>
                    <template v-slot:label>
                      费用名称 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                  <v-text-field v-model="itemform.price" type="number" :rules="[vrules.required]" dense outlined
                    suffix="元">
                    <template v-slot:label>
                      费用 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                  <v-autocomplete v-model="itemform.cycle" :items="[
                    { text: '按天', value: 'day', },
                    { text: '按月', value: 'month', },
                    { text: '按年', value: 'year', },
                  ]" :rules="[vrules.required]" :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense
                    outlined>
                    <template v-slot:label>
                      费用周期 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                  <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
                    :return-value.sync="itemform.date1" transition="scale-transition" min-width="auto" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="itemform.date1" :rules="[vrules.required]" append-icon="mdi-calendar"
                        readonly v-bind="attrs" v-on="on" dense outlined>
                        <template v-slot:label>
                          开始日期 <span class="red--text">*</span>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="itemform.date1" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
                      @input="() => { $refs.menu1.save(itemform.date1); menu1 = false; }"></v-date-picker>
                  </v-menu>
                  <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
                    :return-value.sync="itemform.date2" transition="scale-transition" min-width="auto" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="itemform.date2" append-icon="mdi-calendar" readonly v-bind="attrs"
                        v-on="on" dense outlined clearable>
                        <template v-slot:label>
                          结束日期
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="itemform.date2" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
                      @input="() => { $refs.menu2.save(itemform.date2); menu2 = false; }"></v-date-picker>
                  </v-menu>
                  <v-textarea v-model="itemform.remark" placeholder="备注" persistent-placeholder outlined rows="2" dense>
                    <template v-slot:label>
                      备注
                    </template>
                  </v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" tile :disabled="!itemvalid" @click="saveitem">确定</v-btn>
            <v-btn tile @click="cancelsaveitem">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "CarCost",
  data() {
    return {
      queryForm: {
        own_type: "",
        type: "",
        vehicle_type: "",
      },
      own_types: [],
      types: [],
      vehicle_types: [],
      vehicle_brands: [],
      headers: [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 80, align: "center" },
        { title: "车辆归属", dataIndex: "own_type", scopedSlots: { customRender: "own_type" }, width: 100, align: "center" },//自有、包车
        { title: "车辆类型", dataIndex: "type", scopedSlots: { customRender: "type" }, width: 100, align: "center" },//牵引头、挂箱、载货车头、载货车箱、整车
        { title: "车辆吨数", dataIndex: "vehicle_type", scopedSlots: { customRender: "vehicle_type" }, width: 100, align: "center" },//12d吨、30吨
        { title: "品牌名称", dataIndex: "brand", scopedSlots: { customRender: "brand" }, width: 100, align: "center" },
        { title: "带司机", dataIndex: "include_driver", scopedSlots: { customRender: "include_driver" }, width: 80, align: "center" },
        { title: "金额(元/月)", dataIndex: "cost", scopedSlots: { customRender: "cost" }, width: 100, align: "center" },
        { title: "现有数量", dataIndex: "count", scopedSlots: { customRender: "count" }, width: 100, align: "center" },
        { title: "备注", dataIndex: "remark", scopedSlots: { customRender: "remark" }, width: 100, align: "center" },
        { title: "创建时间", dataIndex: "create_time", scopedSlots: { customRender: "create_time" }, width: 120, align: "center" },
        { title: "更新时间", dataIndex: "update_time", scopedSlots: { customRender: "update_time" }, width: 120, align: "center" },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 260, align: "center" },
      ],
      sheaders: [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 80, align: "center" },
        { title: "费用名称", dataIndex: "name", scopedSlots: { customRender: "name" }, width: 100, align: "center" },
        { title: "金额(元)", dataIndex: "price", scopedSlots: { customRender: "price" }, width: 100, align: "center" },
        { title: "费用周期", dataIndex: "cycle", scopedSlots: { customRender: "cycle" }, width: 100, align: "center" },
        { title: "有效期", dataIndex: "duration", scopedSlots: { customRender: "duration" }, width: 150, align: "center" },
        { title: "备注", dataIndex: "remark", scopedSlots: { customRender: "remark" }, width: 100, align: "center" },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 150, align: "center" },
      ],
      list: [],
      groupmodel: false,
      grouptitle: "",
      groupvalid: true,
      groupform: {},
      itemmodel: false,
      itemtitle: "",
      itemvalid: true,
      itemform: {},
      menu1: false,
      menu2: false,
      vrules: {
        required: (value) => !!value || "不能为空",
      },
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    swidth() {
      return _.reduce(this.sheaders, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: {},
  watch: {
  },
  activated() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclecost/list", { ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
          this.own_types = res.data.own_types;
          this.types = res.data.types;
          this.vehicle_types = res.data.vehicle_types;
          this.vehicle_brands = res.data.vehicle_brands;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showaddgroup() {
      this.groupform = {
        _id: "",
        own_type: null,
        type: null,
        vehicle_type: null,
        include_driver: null,
        brand: null,
        remark: "",
      };
      this.grouptitle = "新增车辆成本";
      this.groupmodel = true;
    },
    showeditgroup(item) {
      this.groupform = {
        _id: item._id,
        own_type: item.own_type,
        type: item.type,
        vehicle_type: item.vehicle_type,
        include_driver: item.include_driver,
        brand: item.brand,
        remark: item.remark,
      };
      this.grouptitle = "编辑车辆成本";
      this.groupmodel = true;
    },
    savegroup() {
      if (!this.$refs.groupformref.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclecost/savegroup", { dataForm: this.groupform }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.groupmodel = false;
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelsavegroup() {
      this.$refs.groupformref.resetValidation();
      this.groupmodel = false;
    },
    removegroup(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclecost/removegroup", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showadditem(groupid) {
      this.itemform = {
        _id: "",
        groupid,
        name: "",
        price: "",
        cycle: "",
        date1: "",
        date2: "",
        remark: "",
      };
      this.itemtitle = "新增车辆成本";
      this.itemmodel = true;
    },
    showedititem(item) {
      this.itemform = {
        _id: item._id,
        name: item.name,
        price: item.price,
        cycle: item.cycle,
        date1: item.date1,
        date2: item.date2,
        remark: item.remark,
      };
      this.itemtitle = "编辑车辆成本";
      this.itemmodel = true;
    },
    saveitem() {
      if (!this.$refs.itemformref.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclecost/saveitem", { dataForm: this.itemform }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.itemmodel = false;
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelsaveitem() {
      this.$refs.itemformref.resetValidation();
      this.itemmodel = false;
    },
    removeitem(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclecost/removeitem", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>
